import { Component, EventEmitter, Input, Output, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'pcp-slide-sync-toolbar-button',
    templateUrl: './toolbar-button.component.html',
    styleUrls: ['./toolbar-button.component.scss'],
    imports: [NgClass, MatIcon]
})
export class ToolbarButtonComponent {
    /** Buttons with custom icons (in css file of the component). Non <mat-icon> icons.  */
    @Input() icon: string = '';
    /** <mat-icon> code */

    @Input() matIcon: string;
    @Input() fontSet: string = '';

    @Input() turnedOn: boolean;
    @Input() disabled = false;
     
    svgIcon = input('');

    @Output() toggle = new EventEmitter<void>();
}
